import React from 'react';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';
import committeeMembersData from '../../data/commiteeMembers';
import './Committee.css';

const Committee = () => {
  return (
    <>
      <Navbar />
      {/* <div id="placement-committee-page">
        <div id="placement-committee-container">
          

          <div id="placement-committee-table-container">
            <h2 id="placement-committee-table-title">Committee Members</h2>
            <table id="placement-committee-table">
              <thead id="placement-committee-thead">
                <tr id="placement-committee-header-row">
                  <th id="placement-committee-th-sno">S.No.</th>
                  <th id="placement-committee-th-name">Name</th>
                  <th id="placement-committee-th-designation">Designation</th>
                </tr>
              </thead>
              <tbody id="placement-committee-tbody">
                {committeeMembersData.map((member, index) => (
                  <tr key={member.id} className="placement-committee-row">
                    <td className="placement-committee-td-sno">{index + 1}</td>
                    <td className="placement-committee-td-name">{member.name}</td>
                    <td className="placement-committee-td-designation">{member.designation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
      <Footer />
    </>
  );
};

export default Committee;
